// extracted by mini-css-extract-plugin
export default {"listbox":"search-bar_listbox__m9H9K","option":"search-bar_option__2Xmc5","paper":"search-bar_paper__wv291","input":"search-bar_input__sbFUh"};